module.exports = __webpack_public_path__ + "Trawick_Logo.jpg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=[name].[ext]!./app/images/Trawick_Logo.jpg
// module id = ./node_modules/file-loader/index.js?name=[name].[ext]!./app/images/Trawick_Logo.jpg
// module chunks = 12